import React from 'react';
import { Sparkles } from 'lucide-react';

export const AnnouncementBar = () => {
  return (
    <div
      className="sticky top-0 z-50 bg-brand-forest text-white border-b border-black/20"
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 sm:py-2.5 flex items-center justify-center gap-2 text-center">
        <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-brand-sage flex-shrink-0" />
        <p className="text-[10px] sm:text-sm font-heading font-semibold uppercase tracking-[0.12em] sm:tracking-[0.22em] leading-tight">
          Complete the quiz · unlock <span className="text-brand-sage">up to 50% off</span> CoQ10
        </p>
        <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-brand-sage flex-shrink-0 hidden sm:inline-block" />
      </div>
    </div>
  );
};
